import React from 'react';
import '../styles/eventcard.css';
import { baseUrl } from '../config';



const EventCard = ({ taskName, time, description, onView, onEdit, onDelete }) => {
  return (
    <div className="event-card">
      <h3>{taskName}</h3>
      <p>{time}</p>
      <div className="event-card-actions">
        <button className="view-btn" onClick={onView}>View</button>
        <button className="edit-btn" onClick={onEdit}>Edit</button>
        <button className="delete-btn" onClick={onDelete}>Delete</button>
      </div>
    </div>
  );
}

export default EventCard;

